import { render, staticRenderFns } from "./TestQuestionReport.vue?vue&type=template&id=6f4c2696&scoped=true"
import script from "./TestQuestionReport.vue?vue&type=script&lang=js"
export * from "./TestQuestionReport.vue?vue&type=script&lang=js"
import style0 from "./TestQuestionReport.vue?vue&type=style&index=0&id=6f4c2696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c2696",
  null
  
)

export default component.exports